<template>
  <div>
    <div class="modal-backdrop fade show"></div>
    <div class="modal fade show" tabindex="-1" style="display:block;" role="dialog">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Artikel bearbeiten: {{ article.Name }}</h5>
            <button type="button" class="btn-close" @click="$emit('close')"></button>
          </div>
          <div class="modal-body">
            <div class="row mb-3" v-if="article.ArticleStatus !== 'sold'">
              <div class="col-md-6">
                <label for="customerSelect" class="form-label">Kunde</label>
                <select id="customerSelect" v-model="article.Customerid" class="form-control">
                  <option v-for="c in customers" :key="c.id" :value="c.id">
                    {{ c.FirstName }} {{ c.LastName }}
                  </option>
                </select>
              </div>
            </div>

            <h6 class="section-title">Allgemeines</h6>
            <div class="row mb-3" v-for="key in editableKeys" :key="key">
              <div class="col-md-6">
                <label :for="key" class="form-label">{{ getLabel(key) }}</label>
                <input :id="key" v-model="article[key]" class="form-control" :type="inputType(key)" />
              </div>
            </div>

            <div class="row mb-4">
              <div class="col-md-6">
                <label class="form-label">Status</label>
                <select v-model="article.ArticleStatus" class="form-control">
                  <option v-for="opt in statusOptions" :key="opt.value" :value="opt.value" :disabled="opt.disabled">
                    {{ opt.label }}
                  </option>
                </select>
              </div>
            </div>

            <h6 class="section-title">Preis</h6>
            <div class="row mb-3">
              <div class="col-md-6">
                <label class="form-label">Original Preis</label>
                <input type="number" v-model="article.SalePrice" class="form-control"
                  :readonly="article.SaleDate !== null" />
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-md-6">
                <label for="receivedDate" class="form-label">Erhalten am</label>
                <input type="date" id="receivedDate" v-model="article.ReceivedDate" class="form-control" />
              </div>
            </div>

            <div class="form-check mb-3">
              <input class="form-check-input" type="checkbox" id="markedForReturn" v-model="article.isMarkedForReturn"
                :disabled="article.ArticleStatus === 'sold'" />
              <label class="form-check-label" for="markedForReturn">
                Für Retour markieren
              </label>
            </div>

            <div class="mb-3">
              <label for="comment" class="form-label">Kommentare</label>
              <textarea id="comment" v-model="article.Comment" class="form-control" rows="3"
                placeholder="Kommentare..."></textarea>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-secondary" @click="$emit('close')">Abbrechen</button>
            <button class="btn btn-primary" @click="saveArticle">Speichern</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@/services/axios';

export default {
  props: ['article'],
  data() {
    return {
      editableKeys: ['Name', 'Color', 'Size', 'Gender'],
      customers: []
    };
  },
  computed: {
    statusOptions() {
      const options = [
        { label: 'Lagernd', value: 'available' },
        { label: 'Retourniert', value: 'returned' },
        { label: 'Entsorgt', value: 'disposed' }
      ];
      if (this.article.ArticleStatus === 'sold') {
        options.push({ label: 'Verkauft', value: 'sold', disabled: true });
      }
      return options;
    }
  },
  methods: {
    inputType(key) {
      return key.toLowerCase().includes('date') ? 'date' : 'text';
    },
    getLabel(key) {
      const map = {
        Name: 'Bezeichnung',
        Color: 'Farbe',
        Size: 'Größe',
        Gender: 'Geschlecht'
      };
      return map[key] || key;
    },
    formatDateForInput(date) {
      return date ? new Date(date).toISOString().substr(0, 10) : '';
    },
    async loadCustomers() {
      try {
        const res = await axios.get('/customers');
        this.customers = res.data;
      } catch (e) {
        console.error('Kunden konnten nicht geladen werden', e);
      }
    },
    saveArticle() {
      this.$emit('save', this.article);
    }
  },
  mounted() {
    if (this.article.ReceivedDate) {
      this.article.ReceivedDate = this.formatDateForInput(this.article.ReceivedDate);
    }
    this.loadCustomers();
  }
};
</script>

<style scoped>
.section-title {
  font-size: 1.1rem;
  font-weight: bold;
  margin-top: 1rem;
  margin-bottom: 0.5rem;
}

.btn-primary {
  background-color: #1e88e5;
  border-color: #1e88e5;
}

.btn-primary:hover {
  background-color: #1565c0;
  border-color: #1565c0;
}
</style>
